<template>
<div>
  <div class="text-box" v-on:click="wordSelect" v-html="pagetext"> 
  </div>
</div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex'

export default {
  props: ['pagetext','pageNr', 'isbn'],
  data(){
    return {
      wordSelection: '0',
      wordTranslation: '0'
    }
  },
  computed: {
  ...mapGetters([
    'getHasPagesDicInStore',
    'getCurrentPageStore',
  ]),
  },
  methods: {
    wordSelect: function(event) {
      var x = event.target
      if(x.tagName === 'SPAN') {
        this.wordSelection = x.innerHTML
        this.wordSelection = this.wordSelection.toLowerCase()
        this.wordLookupV2(this.wordSelection, this.getCurrentPageStore, this.isbn)
      } else {
      }
    },
    wordLookup: function(word) {
      axios
      .get(`https://us-central1-spanish-books-co-1585502105544.cloudfunctions.net/wordsLookup?word=${word}`)
      .then((response) => {
        this.wordTranslation = response.data
        this.$store.commit('setLookupWords', {
          eng: this.wordTranslation, 
          esp: this.wordSelection,
          })
      })
      .catch((error) => {
        this.$store.commit('closeLookupModal')
        console.error(error);
      });
    },
    wordLookupV2: function(word, pageNr, isbn) {
      this.$store.commit('setLookupWordsV2', {queryText: word, wordLoading: true})
      this.$store.commit('openLookupModal')
      if(word && isbn) {
        word = word.toLowerCase()
        axios
        .get(`https://us-central1-spanish-books-co-1585502105544.cloudfunctions.net/wordsLookupV2?word=${word}&isbn=${isbn}&page=${pageNr}`)
        .then((response) => {
          var data = response.data
          let fullObj, verbObj
          for (var key in data) {
            if(data[key] == null) {
              continue
            }
            if (data.hasOwnProperty(key)) {
              if(data[key].verbInfo) {
                verbObj = {
                  person: (data[key].verbInfo.person != null) ? data[key].verbInfo.person : null,
                  personIdx: (data[key].verbInfo.personIdx != null) ? data[key].verbInfo.personIdx : null,
                  query: (data[key].verbInfo.query != null) ? data[key].verbInfo.query : null,
                  word: (data[key].verbInfo.word != null) ? data[key].verbInfo.word : null,
                  tense: (data[key].verbInfo.tense != null) ? data[key].verbInfo.tense : null,
                  tenseName: (data[key].verbInfo.tenseName != null) ? data[key].verbInfo.tenseName : null,
                  variationTranslation: (data[key].verbInfo.variationTranslation != null) ? data[key].verbInfo.variationTranslation : null,
                  verbSupplementalInfinitive: (data[key].verbInfo.verbSupplementalInfinitive != null) ? data[key].verbInfo.verbSupplementalInfinitive : null,
                }
              } else {
                verbObj = null
              }
              fullObj = {
                verb: data[key].verb,
                queryText: (data[key].queryText != null) ? data[key].queryText.toLowerCase() : null,
                def1: (data[key].def1 != null) ? data[key].def1 : null,
                def2: (data[key].def2 != null) ? data[key].def2 : null,
                verbInfo: verbObj
              }
            }
          }
          this.$store.commit('setLookupWordsV2', fullObj)
        })
        .catch((error) => {
          this.$store.commit('closeLookupModal')
          console.error(error);
        });
      } else {
        console.log('Need some information to request')
      }
      
    }
  }
}
</script>

<style>
.text-box p{
  margin: 0;
}

.text-box li {
  margin-bottom: 15px;
  list-style-type: circle;
}
.text-box .word-box {
  cursor: pointer;
}
.text-box {
  text-align: left;
  /* background-color: whitesmoke; */
  max-width: 500px;
  margin: 0 auto;
  padding: 0 15px 15px 15px;
}
</style>
